import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Divider,
  Paper,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import "../../../styles/CustomerDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerDashboardDataRequest } from "../../../redux/Dashboard/DashboardAction";
import { formatDatetimeWithAMPM } from "../../../Style";
import { BOOKING_AIRPORT_DETAILS } from "../Routes/AppRoutes";
import { CUSTOMER_BOOKING_AIRPORT_DETAILS } from "../Routes/CustomerRoutes";
import { useNavigate } from "react-router-dom";
import { fetchCustomerDetailsRequest } from "../../../redux/Customers/actions/customerActions";
import { requestForToken } from "../../../firebase";
import { registerDeviceApi } from "../../../redux/auth/Effects/AuthEffect";

const CustomerDashBoard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { customerData, loading, error } = useSelector(
    (state) => state.dashboard,
  );
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const registerDeviceOnce = async () => {
      const fcmToken = await requestForToken();
      if (fcmToken) {
        let deviceId = localStorage.getItem("deviceId");
        deviceId =
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15);

        try {
          await registerDeviceApi({
            deivceId: deviceId,
            device_token: fcmToken,
            customer_id: user.customer_id,
          });
          localStorage.setItem("isDeviceRegistered", "true");
        } catch (error) {
          console.error("Device registration failed:", error);
        }
      }
    };
    if (user.customer_id != null) {
      registerDeviceOnce();
    }
  }, [user]);

  const customerDetailsState = useSelector(
    (state) => state.customers.customerDetails?.data?.data,
  );

  useEffect(() => {
    if (user) {
      dispatch(fetchCustomerDetailsRequest(user.customer_id));
    }
  }, []);
  const [isRedirectOpen, setRedirectOpen] = useState(true);

  const handleCloseRedirect = () => {
    setRedirectOpen(false);
  };
  useEffect(() => {
    dispatch(fetchCustomerDashboardDataRequest());
  }, [dispatch]);

  const upcomingBookings = customerData?.servicebookings?.filter((booking) => {
    const departureDate = booking?.BookingDetail?.date_of_departure
      ? new Date(booking?.BookingDetail?.date_of_departure)
      : null;
    const arrivalDate = booking?.BookingDetail?.date_of_arrival
      ? new Date(booking?.BookingDetail?.date_of_arrival)
      : null;
    const currentDate = new Date();

    return (
      (departureDate && departureDate > currentDate) ||
      (arrivalDate && arrivalDate > currentDate)
    );
  });

  const serviceHistory = customerData?.servicebookings?.filter(
    (booking) => booking?.status === 1 || booking?.status === 3,
  );

  return (
    <Box className="container">
      <Grid container spacing={3} className="bottom-spacing">
        {/* Total Bookings */}
        <Grid item xs={12} sm={4}>
          <Paper className="paper-card">
            <CalendarTodayIcon className="icon-blue" />
            <Box>
              <Typography variant="h6" className="text-blue-heading">
                Total Bookings
              </Typography>
              <Typography variant="h4" className="text-blue-value">
                {customerData?.count?.totalBookingCount}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className="paper-card">
            <AssignmentTurnedInIcon className="icon-green" />
            <Box>
              <Typography variant="h6" className="text-green-heading">
                Completed Bookings
              </Typography>
              <Typography variant="h4" className="text-green-value">
                {customerData?.count?.totalCompletedBookingCount}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className="paper-card">
            <EventAvailableIcon className="icon-red" />
            <Box>
              <Typography variant="h6" className="text-red-heading">
                Cancelled Bookings
              </Typography>
              <Typography variant="h4" className="text-red-value">
                {customerData?.count?.totalCancelBookingCount}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Box sx={{ textAlign: "center", my: 2 }}>
        {customerDetailsState?.phone != null && (
          <Button
            variant="contained"
            size="small"
            startIcon={<AddCircleOutlineIcon />}
            sx={{
              bgcolor: "#ff7043",
              "&:hover": { bgcolor: "#f4511e" },
              py: 1.5,
              px: 4,
              fontSize: "1.1rem",
              fontWeight: "bold",
              boxShadow: 3,
            }}
            onClick={() => {
              navigate(CUSTOMER_BOOKING_AIRPORT_DETAILS);
            }}
          >
            Book Now
          </Button>
        )}
      </Box>

      <Dialog
        open={isRedirectOpen && customerDetailsState?.phone == null}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            borderRadius: "15px",
            padding: "20px",
            minWidth: "400px",
            textAlign: "center",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontWeight: "bold", fontSize: "1.5rem", color: "#d32f2f" }}
        >
          {"Profile Update Required"}
          <IconButton
            aria-label="close"
            onClick={handleCloseRedirect}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "1.2rem", color: "#333" }}
          >
            Kindly update your profile to proceed with bookings.
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card className="card">
            <CardContent>
              <Typography variant="h5" className="heading">
                Upcoming Bookings
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Box className="list-container">
                <List>
                  {upcomingBookings?.length > 0 ? (
                    upcomingBookings.map((booking) => (
                      <ListItem key={booking.id} className="list-item">
                        <ListItemText
                          primary={`${booking.booking_serial_no} - ${booking.Airport.name}`}
                          secondary={
                            booking.BookingDetail.date_of_departure &&
                            booking.BookingDetail.date_of_arrival
                              ? `Departure: ${booking.BookingDetail.date_of_departure} at ${booking.BookingDetail.time_of_departure} | Arrival: ${booking.BookingDetail.date_of_arrival} at ${booking.BookingDetail.time_of_arrival}`
                              : booking.BookingDetail.date_of_departure
                                ? `Departure: ${booking.BookingDetail.date_of_departure} at ${booking.BookingDetail.time_of_departure}`
                                : booking.BookingDetail.date_of_arrival
                                  ? `Arrival: ${booking.BookingDetail.date_of_arrival} at ${booking.BookingDetail.time_of_arrival}`
                                  : "No travel details available"
                          }
                        />
                        {/* <Button variant="contained" className="orange-button">
                          Manage
                        </Button> */}
                      </ListItem>
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No upcoming bookings found.
                    </Typography>
                  )}
                </List>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card className="card">
            <CardContent>
              <Typography variant="h5" className="heading">
                Service History
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <Box className="list-container">
                {serviceHistory?.length > 0 ? (
                  serviceHistory.map((booking) => {
                    const formattedDate = formatDatetimeWithAMPM(
                      booking.Service.created_at,
                    );
                    return (
                      <Box key={booking.service_id} className="service-box">
                        <Box>
                          <Typography variant="h6">
                            {booking.Service.services}
                          </Typography>
                          <Typography variant="body2">
                            Date: {formattedDate}
                          </Typography>
                        </Box>
                        {booking.Service.status === 1 ? (
                          <AssignmentTurnedInIcon className="icon-green" />
                        ) : (
                          <EventAvailableIcon className="icon-red" />
                        )}
                      </Box>
                    );
                  })
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No Services found.
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerDashBoard;
